import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { CREATE_WAREHOUSE } from "../apollo/mutations";
import closeModal from "../common/closeModal";
import { getCities, getCountries, getStates } from "../utils/country";
import {
  getSelectedStoreDetails,
  payloadValidator,
} from "../utils/helperFunctions";

const useCreateWarehouse = (refetch) => {
  const defaultValues = {
    name: "",
    phone: "",
    store_id: getSelectedStoreDetails("id"),
    address: {
      address: "",
      country: "",
      city: "",
      state: "",
      zip: "",
    },
  };

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues });

  const [submit, { loading }] = useMutation(CREATE_WAREHOUSE);

  const onAddWarehouse = async (data) => {
    try {
      const payload = {
        ...data,
        address: {
          ...data.address,
          address: data?.address?.address ?? "",
          country: data?.address?.country.value ?? "",
          city: data?.address?.city.value ?? "",
          state: data?.address?.state.value ?? "",
        },
      };

      await submit(payloadValidator(payload));
      reset(defaultValues);
      closeModal("add-units");
      refetch();
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
  };

  const country = watch("address.country");
  const state = watch("address.state");

  const resetField = (field) => setValue(field, "");

  return {
    values: {
      control,
      errors,
      loading,
      setValue,
      countries: getCountries(),
      states: country ? getStates(country?.country_id) : [],
      cities:
        country && state ? getCities(state.country_id, state.state_id) : [],
    },
    functions: {
      onSubmit: handleSubmit(onAddWarehouse),
      onCancel,
      resetField,
    },
  };
};

export default useCreateWarehouse;
